<div class="table-responsive" *ngIf="_isAnnual && !noDataAnnual">
   <table class="table">
      <thead>
         <tr>
            <th width="320">Currency: USD</th>
            <th class="text-right" *ngFor="let year of years" style="text-align: right">
               {{ year }}
            </th>
         </tr>
      </thead>
      <tbody>
         <ng-container *ngFor="let item of processedData">
            <!-- Parent row -->
            <tr [ngClass]="{
                  'parent-row': item.children?.length,
                  'level-0': !item.children?.length,
                  'has-children': item.children?.length
               }" (click)="toggleRow(item)">
               <td [title]="item.label | keyToLabel" class="truncated-label">
                  <div class="d-flex align-items-center gap-1 justify-content-between">
                     <div class="d-flex align-items-right gap-1">
                        <a *ngIf="item.children?.length" class="btn btn-link p-0 mr-2"
                           (click)="toggleRow(item); $event.stopPropagation()" style="color: black;">
                           <i class="fas" [class.fa-chevron-down]="expandedRows[item.label]"
                              [class.fa-chevron-right]="!expandedRows[item.label]"></i>
                        </a>
                        {{ item.label | keyToLabel }}
                     </div>
                     <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                        src="../../../../../../assets/icons/icon-info.svg" /> -->
                  </div>
               </td>
               <td *ngFor="let year of years" class="text-right" style="text-align: right"
                  (click)="$event.stopPropagation()">
                  <!-- Check if label is 'dilutedEPS', if so, show raw value -->
                  <ng-container *ngIf="
                        item.label === 'dilutedEPS';
                        else formattedParentValue
                     ">
                     {{ item.data[year] }}
                  </ng-container>
                  <ng-template #formattedParentValue>
                     {{ formatValue(item.data[year]) }}
                  </ng-template>
               </td>
            </tr>

            <!-- Child rows -->
            <ng-container *ngIf="item.children?.length && expandedRows[item.label]">
               <tr *ngFor="let child of item.children" class="child-row">
                  <td [title]="child.label | keyToLabel" class="truncated-label">
                     <div class="d-flex align-items-center" [style.padding-left.px]="20">
                        {{ child.label | keyToLabel }}
                     </div>
                  </td>
                  <td *ngFor="let year of years" class="text-right" style="text-align: right">
                     <!-- Check if label is 'dilutedEPS', if so, show raw value -->
                     <ng-container *ngIf="
                           child.label === 'dilutedEPS';
                           else formattedValue
                        ">
                        {{ child.data[year] }}
                     </ng-container>
                     <ng-template #formattedValue>
                        {{ formatValue(child.data[year]) }}
                     </ng-template>
                  </td>
               </tr>
            </ng-container>
         </ng-container>
      </tbody>
   </table>
</div>
<div *ngIf="noDataAnnual && _isAnnual" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Annual Data Available!</p>
</div>

<div class="table-responsive" *ngIf="!_isAnnual && !noDataQuarterly">
   <table class="table">
      <thead>
         <tr>
            <th width="320">Currency: USD</th>
            <th class="text-right" *ngFor="let quarter of quarters" style="text-align: right">
               {{ quarter }}
            </th>
         </tr>
      </thead>
      <tbody>
         <ng-container *ngFor="let item of processedQuarterlyData">
            <!-- Parent row -->
            <tr *ngIf="hasData(item.data)" [class.parent-row]="item.children" (click)="toggleRow(item)">
               <td [title]="item.label | keyToLabel" class="truncated-label">
                  <div class="d-flex align-items-center gap-1 justify-content-between">
                     <div class="d-flex align-items-right gap-1">
                        <a *ngIf="item.children && hasData(item.data)" class="btn btn-link p-0 mr-2"
                           (click)="toggleRow(item); $event.stopPropagation()" style="color: black;">
                           <i class="fas" [class.fa-chevron-down]="expandedRows[item.label]"
                              [class.fa-chevron-right]="!expandedRows[item.label]"></i>
                        </a>
                        {{ item.label | keyToLabel }}
                     </div>
                     <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                        src="../../../../../../assets/icons/icon-info.svg" /> -->

                  </div>
               </td>
               <td *ngFor="let quarter of quarters" class="text-right" style="text-align: right"
                  (click)="$event.stopPropagation()">
                  <!-- If label is 'dilutedEPS', show raw value -->
                  <ng-container *ngIf="item.label === 'dilutedEPS'; else formattedQuarterValue">
                     {{ item.data[quarter] }}
                  </ng-container>
                  <ng-template #formattedQuarterValue>
                     {{ formatValue(item.data[quarter]) }}
                  </ng-template>
               </td>

            </tr>

            <!-- Child rows -->
            <ng-container *ngIf="item.children && expandedRows[item.label]">
               <tr *ngFor="let child of item.children" class="child-row" [class.d-none]="!hasData(child.data)">
                  <td [title]="child.label | keyToLabel" class="truncated-label">
                     <div class="d-flex align-items-center gap-1 justify-content-between">
                        <div class="d-flex align-items-center" [style.padding-left.px]="20">
                           {{ child.label | keyToLabel }}
                        </div>
                        <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                           src="../../../../../../assets/icons/icon-info.svg" /> -->

                     </div>
                  </td>
                  <td *ngFor="let quarter of quarters" class="text-right" style="text-align: right">
                     {{ formatValue(child.data[quarter]) }}
                  </td>
               </tr>
            </ng-container>
         </ng-container>
      </tbody>
   </table>
</div>
<div *ngIf="noDataQuarterly && !_isAnnual" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Quarterly Data Available!</p>
</div>
